import clsx from "classnames";
import Image from "@/ui/Image";
import { TabList } from "@/ui/TabList";
import { useLocale } from "@/hooks/useLocale";
import classes from "./styles.module.scss";
import { tbd_helper } from "@/helpers/tbd_helper";
import { cleanMarkup } from "@/functions/cleanMarkup";

export const CulturePageRewardsSection = ({ className }) => {
  const items = tbd_helper.fetch();
  const locale = useLocale();

  return (
    <div className={clsx(className, classes.tabs)}>
      <TabList
        title={{ path: "page.culture.tbd.title" }}
        text={{ path: "page.culture.tbd.text" }}
        variant="multicolor"
        items={items.map((i, k) => ({
          title: i[`title_${locale}`],
          content: (
            <div key={k} className={clsx(classes.tabs__content, "p-4 p-md-5 me-md-5")}>
              <Image img={i.icon} size="100x100" alt="" className="mb-4" />
              <div className="mx-md-5" dangerouslySetInnerHTML={{ __html: cleanMarkup(i[`text_${locale}`]) }} />
            </div>
          ),
        }))}
      />
    </div>
  );
};

CulturePageRewardsSection.defaultProps = {
  className: "py-4 py-md-5",
};
